import { FIND_RIDE_COLORS } from "../constants/findRide.constants";
import { tFindRide } from "../locales/FindRideTranslations";

export function FindRideHero() {
  return (
    <header className="px-1 text-center sm:px-0">
      <h1
        className="text-2xl font-extrabold tracking-tight sm:text-3xl md:text-4xl"
        style={{ color: FIND_RIDE_COLORS.pageGreen }}
      >
        {tFindRide("heroTitle")}
      </h1>
      <p className="mx-auto mt-2 max-w-md text-sm leading-snug text-gray-700 sm:max-w-none sm:text-base sm:leading-normal md:text-lg">
        {tFindRide("heroSubtitleBefore")}
        <span
          className="font-semibold"
          style={{ color: FIND_RIDE_COLORS.accentGreen }}
        >
          {tFindRide("heroSubtitleHighlight")}
        </span>
        {tFindRide("heroSubtitleAfter")}
      </p>
    </header>
  );
}
